function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.70708 1.70711C4.0976 1.31658 4.73077 1.31658 5.12129 1.70711L20.6776 17.2635C21.0682 17.654 21.0682 18.2871 20.6776 18.6777C20.2871 19.0682 19.654 19.0682 19.2634 18.6777L3.70708 3.12132C3.31655 2.7308 3.31655 2.09763 3.70708 1.70711Z",
  fill: "#FBFFFE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.12129 18.7071C3.73077 18.3166 3.73077 17.6834 4.12129 17.2929L19.6776 1.73654C20.0682 1.34602 20.7013 1.34602 21.0919 1.73654C21.4824 2.12707 21.4824 2.76023 21.0919 3.15076L5.53551 18.7071C5.14498 19.0976 4.51182 19.0976 4.12129 18.7071Z",
  fill: "#FBFFFE"
});

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.069a71cb.svg";
export { ForwardRef as ReactComponent };